/**
 * Core – Stores / Integrations (shared across projects)
 */

export default {
  stores: {
    store: "Store",
    stores: "Stores",
    addStore: "Add store",
    removedTest:
      "You are about to end the trial phase of your website. This means all test transactions of the website will be removed and all new transactions will be billed. Are you sure you are ready to proceed",
    cancel: "Cancel",
    reset: "Reset",
    reseting: "Reseting",
    status: "Status",
    update: "Update",
    privPol: "Privacy Policy",
    domestic: "Domestic Country",
    contact: "Please, contact our",
    supportTeam: "support team",
    dot: ".",
    resetToken: "Are you sure want to reset token",
    oldToken:
      "New transactions with old token will not be accepted, be sure to change it as soon as possible",
    activating: "Activating",
    warning: "Warning",
    del: "Delete",
    activate: "Activate",
    setting: "Setting",
    needAddStore: "You need to add your site, to start work with Lappa.",
    needAddIntegration: "You need to add your integration, to start work with Lappa.",
    aware: "I am aware that all transactions of this store will be deleted.",
    specStore: "The specified store",
    exists: "already exists.",
    planOver: "Your tarrif plan is over",
    contUsing: "You can continue using Lappa software when you subscribe.",
    selectPlan: "select plan",
    sureDel1: "Are you sure you want to delete the store?",
    sureDel2: "Are you sure you want to delete the project?",
    token: "Access Token",
    addStoreError: "Error adding store",
    err: {
      emailInvalid: "Invalid email",
    },
    hereYouCanManage:
      "Here you can manage all your stores. You can add new ones or remove old ones and make changes to configurations.",
    hereYouCanManageIntegrations:
      "Here you can manage all your integrations. You can add new ones or remove old ones and make changes to configurations.",
    typesOfGoods: "Types of goods or services",
    typesOfGoodsNotSelected: "Types of goods or services not selected",
    youCanAddTypesOfGoods: "You can add types of goods or services",
    tableOfGoods: "Table of goods and services",
    select: "Select",
    selectTypesOfGoods: "Select types of goods and services",
    addNewGood: "Add new good or service",
    delete: "Delete",
    addNew: "Add new",
    projectName: "Project name:",
    storeName: "Store name:",
    projectUrl: "Project url",
    storeUrl: "Store url",
    integrationUrl: "Integration url",
    integrationWasSuccessfull: "Integration was successfull!",
    connectProject: "Connect project",
    connectStore: "Connect store",
    cancelIntegration: "Cancel integration",
    discard: "Discard",
    saveChanges: "Save changes",
    editSettings: "Edit settings",
    project: "Project",
    approvalOfProject:
      "The approval of the project may take up to 2 working days.",
    approvalOfStore: "The approval of the store may take up to 2 working days.",
    addProject: "Add project",
    specProject: "The specified project",
    needAddProject: "You need to add your project, to start work with Lappa.",
    selectStatus: "Please select the status to change",
    change: "Change",
    aware2: "I am aware that all transactions of this project will be deleted.",
    departureState: "Default departure state:",
    departureZip: "Default departure zip:",
    dataSuccessfullyChanged: "Data has been successfully changed",
    platform: "Platform",
    defaultWarehouse: "Default warehouse country:",
    integration: "Integration",
    currency: "Currency",
    sellerCentralCountry: "Seller Central Country",
    apiKey: "Api key",
    accessSecret: "Access secret",
    accessToken: "Access token",
    clientSecret: "Client secret",
    clientKey: "Client key",
    clientId: "Client id",
    type: "Type",
    code: "Code",
    desc: "Description",
    add: "Add",
    yourAmazonRegEmail: "Your Amazon Registered Email",
  },
  addStore: {
    stores: "Stores",
    integrations: "Integrations",
    addStore: "Add store",
    addIntegration: "Add integration",
    enterName: "Please enter store name",
    enterCountry: "Please enter country",
    enterCurrency: "Please enter currency",
    doYouSell: "How do you prefer to integrate?",
    doYouSellDesc:
      "You can connect your system through a supported platform or set up a custom integration using our API.",
    yesIsell: "Connect via pre-built integration",
    noIhave: "Integrate via API",
    chooseInt: "Choose integration",
    chooseIntDesc1:
      "You can connect webservice you already use to integrate you orders and transactions data for automative VAT calculation.",
    chooseIntDesc2:
      "Marketplace and shopping carts integration is in development. If the system you use is not represented here, you can contact our ",
    chooseIntDescST: "support team.",
    availableWS: "Available web services",
    inDev: "Services in development",
    shopify: {
      title: "Enter your Shopify store URL",
      step1:
        "Enter your Shopify store URL or install directly at Shopify app store",
      step2: "Log in your Shopify account",
      step3: 'Click on "Add App" button',
    },
    amazon: {
      title: "Connect your Amazon account",
      connect: "Connect Amazon",
    },
    ebay: {
      title: "Enter your eBay store name",
    },
    etsy: {
      title: "Enter your Etsy store name",
      desc1: `The term 'Etsy' is a trademark of Etsy, Inc.`,
      desc2:
        "This application uses the Etsy API but is not endorsed or certified by Etsy, Inc.",
    },
    storeURL: "Store URL",
    storeName: "Store name",
    connectStore: "Connect store",
    provideWith: "Please provide with site parameters",
    inModeration:
      "Your submission is in moderation. We'll notify you when all done.",
    typesOf: "Types of services",
    submitStore: "Create store",
    dmCountry: "Domestic Country",
    dmCurrency: "Default Currency",
    discard: "Discard",
    err: {
      emailInvalid: "Invalid email",
    },
    enterWooComm: "Enter your WooCommerce data",
    hereYouCanConnect: "Here you can connect your store",
    hereYouCanConnectIntegration: "Here you can connect your integration",
  },
};
